import React from 'react';
import { Box, Skeleton } from '@mui/material';

const OffRoadPromoSectionSkeleton = () => (
  <Box>
    <Skeleton variant="rectangular" width="100%" height={800} />
  </Box>
);
export { OffRoadPromoSectionSkeleton };
